
import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Navbar from '../../Components/Navbar';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Table.css';
import { API_BASE_URL } from '../../config';

export default function ViewApplication() {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate hook

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/ViewApplication.php`);
        setApplications(response.data);
        setFilteredApplications(response.data); // Initialize with all data
      } catch (error) {
        console.error('Error fetching applications:', error);
      }
    };

    fetchApplications();
  }, []);

  useEffect(() => {
    const filteredByStatus = selectedStatus
      ? applications.filter((app) => app.Status === selectedStatus)
      : applications;

    const filteredByYear = selectedYear
      ? filteredByStatus.filter((app) => new Date(app.submittedDate).getFullYear() === parseInt(selectedYear))
      : filteredByStatus;

    setFilteredApplications(filteredByYear);
  }, [selectedStatus, selectedYear, applications]);

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  // const handleViewClick = (Id) => {
  //   navigate(`/view-application/${Id}`); // Navigate to the detailed view page
  // };
  const handleViewClick = async (app_ID) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
        responseType: 'blob', // Expect binary data (PDF file)
      });
  
      // Create a Blob object and generate a download link
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      // link.download = `Application_${app_ID}.pdf`; // Set the downloaded file's name
      link.download = `Application_${new Date().getFullYear()}_${app_ID}.pdf`;
      link.click();
  
      // Cleanup
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading the file:', error);
      alert('An error occurred while downloading the application.');
    }
  };
  const handleClick = (app_ID) => {
    navigate(`/moredetails/${app_ID}`); // Correctly use template literal
  };
  
  const handleDeleteClick = async (app_ID) => {
    if (window.confirm('Are you sure you want to delete this application?')) {
      try {
        // Send the request to delete the application
        const response = await axios.post(`${API_BASE_URL}/DeleteApplication.php`, { app_ID });
  
        if (response.data.success) {
          // Update state to remove the deleted application
          setApplications(applications.filter((app) => app.app_ID !== app_ID));
          alert('Application deleted successfully.');
        } else {
          alert(`Failed to delete application: ${response.data.message}`);
        }
      } catch (error) {
        console.error('Error deleting application:', error);
        alert('An error occurred while deleting the application.');
      }
    }
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">View Applications</h1>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th colSpan={5} className="dropdown-row">
              <label htmlFor="year-select">Year: </label>
              <select id="year-select" onChange={handleYearChange}>
                <option value="">Select Year</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
              </select>
              
              <label htmlFor="status-select">Status: </label>
              <select id="status-select" onChange={handleStatusChange}>
                <option value="">Select Status</option>
                <option value="Submitted">Submitted</option>
                <option value="Shortlisted">Shortlisted</option>
                <option value="Granted">Granted</option>
                <option value="Pending Approvals">Pending Approvals</option>
                <option value="Reviewers Comments">Reviewers Comments</option>
                <option value="Rejected">Rejected</option>
                <option value="Deny">Deny</option>
              </select>
            </th>
          </tr>
          <tr>
            <th>Appliant Name</th> 
            <th>Application Id</th>
            <th>Project Title</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>View Grant (PDF)</th>
            <th>Application Details</th>
            <th>Delete Application</th>
          </tr>
        </thead>
        <tbody>
          {filteredApplications.map((app) => (
            <tr key={app.app_ID}>
              <td>{app.name}</td>
              <td>{`${app.app_ID}_${new Date().getFullYear()}`}</td>
              <td>{app.projectTitle}</td>
              <td>{app.submittedDate}</td>
              <td>{app.Status}</td> {/* Display the status from application table */}
              <td>
                <button 
                  className="view-button" // Add your custom class name for styling
                  onClick={() => handleViewClick(app.app_ID)} // Handle button click
                >
                 Application
                </button>
              </td>
              <td>
                <button 
                  className="moreDetails-button" // Add your custom class name for styling
                  onClick={() => handleClick(app.app_ID)} // Navigate to More Details
                >
                 More Details
                </button>
              </td>
              <td>
                <button className="delete-button" onClick={() => handleDeleteClick(app.app_ID)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

